export enum FilterTabsType {
    ALL,
    SUBSCRIBED,
    FAVOURITES,
    OUT_OF_HOME,
}
